(function () {
  const note = document.getElementById('stickyNote');
  const textarea = document.getElementById('noteText');
  if (!note || !textarea) return;
  let isDragging = false;
  let currentX;
  let currentY;
  let initialX;
  let initialY;

  // Load saved position and text
  const savedPos = JSON.parse(localStorage.getItem('notePos') || '{}');
  if (savedPos.x && savedPos.y) {
    note.style.right = 'auto';
    note.style.left = savedPos.x + 'px';
    note.style.top = savedPos.y + 'px';
  }

  const savedText = localStorage.getItem('noteText');
  if (savedText) {
    textarea.value = savedText;
  }

  // Save text on input
  textarea.addEventListener('input', () => {
    localStorage.setItem('noteText', textarea.value);
  });

  note.addEventListener('mousedown', dragStart);
  document.addEventListener('mousemove', drag);
  document.addEventListener('mouseup', dragEnd);

  // Prevent dragging when interacting with textarea
  textarea.addEventListener('mousedown', (e) => {
    e.stopPropagation();
  });

  function dragStart(e) {
    if (e.target === textarea) return;

    initialX = e.clientX - (note.offsetLeft || window.innerWidth - note.offsetWidth - 20);
    initialY = e.clientY - note.offsetTop;

    isDragging = true;
    note.style.cursor = 'grabbing';
  }

  function drag(e) {
    if (isDragging) {
      e.preventDefault();
      currentX = e.clientX - initialX;
      currentY = e.clientY - initialY;

      note.style.right = 'auto';
      note.style.left = currentX + 'px';
      note.style.top = currentY + 'px';
    }
  }

  function dragEnd() {
    if (isDragging) {
      isDragging = false;
      note.style.cursor = 'move';

      // Save position
      localStorage.setItem(
        'notePos',
        JSON.stringify({
          x: note.offsetLeft,
          y: note.offsetTop,
        }),
      );
    }
  }

  function closeNote() {
    note.style.display = 'none';
    localStorage.setItem('noteClosed', 'true');
  }

  // Check if note was closed
  if (localStorage.getItem('noteClosed') === 'true') {
    note.style.display = 'none';
  }
})();
